import React from "react";
import { Box, Button, Checkbox, Divider, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Stack, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useProfile } from "../../../common/useProfile";
import Service from "../../../../util/Service";
import { Tree, TreeNode } from "react-organizational-chart";

const MyPaper = styled(Paper)(({ theme }) => ({
    margin: theme.spacing(2),
    padding: theme.spacing(2)
}));

export default function ProfilePanel() {
    const prof = useProfile();
    const [regras, setRegras] = React.useState();
    const [org, setOrg] = React.useState({ nome: "Root" });
    const [checked, setChecked] = React.useState([]);
    const [solicitarAcesso, setSolicitarAcesso]= React.useState(false);

    React.useEffect(() => {
        if (prof.isOk) {
            buscaOrganograma();
            buscaRegras();
            setChecked(prof.profile.rules)
        }
    }, [prof.isOk])

    function buscaRegras() {
        Service.GET("/api/acesso/findAll").then(r => setRegras(r))
    }
    function buscaOrganograma() {
        Service.GET('/api/security/organograma/findAll').then(r => {
            if (r) {
                let root = filtraPorProfile(r[0], prof.profile.email)

                setOrg(root);
            }
        })
    }
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSolicitarAcesso(true);

        setChecked(newChecked);
    };


    function filtraPorProfile(tree, email) {
        if (!tree) {
            return null;
        }
        const filteredChildren = [];
        if (tree.lstArvore && tree.lstArvore.length > 0) {
            for (const child of tree.lstArvore) {
                const filteredChild = filtraPorProfile(child, email);
                if (filteredChild) {
                    filteredChildren.push(filteredChild);
                }
            }
        }
        var item = (tree.membros && tree.membros.find(m => m.email === email));
        if( !item )item = (tree.membros && tree.responsaveis.find(m => m.email === email));

        const passesCondition = item || filteredChildren.length > 0;

        if (passesCondition) {
            if (item) {
                // Create a new node with the filtered children
                return {
                    ...tree, // Copy all properties from the original node
                    lstArvore: filteredChildren,
                };
            } else {
                return {
                    nome: tree.nome,
                    descricao: tree.descricao,
                    membros: tree.membros,
                    responsaveis: tree.responsaveis,
                    lstArvore: filteredChildren,
                }
            }
        } else {
            return null; // Node and its descendants do not meet the criteria
        }
    }

    if (!prof.isOk) {
        return (
            <p>aguarde....</p>
        )
    }
    function getBtnNome(){
        let qtdMore = 0;
        let qtdLess = 0;
        for(let x of checked ){
            const n = prof.profile.rules.includes(x);
            console.log( n );
            if( !n) qtdMore++;
        }
        qtdLess = prof.profile.rules.length - checked.length;   
        if( qtdMore === 0 && qtdLess != 0 ){
            return "Solicitar retirar acesso";
        }else if(qtdMore > 0 &&  qtdLess != 0){
            return "Solicitar revisão acesso";
        }else if( qtdMore === 0 ){
            setSolicitarAcesso(false);
        }
        return "Solicitar acesso";
    }
    function handleAcesso(){
        alert('Ainda não implementado, falta priorizar!');
    }
    const TreeRecursivo = ({ item }) => {
        return (
            <TreeNode label={
                <StyledNode
                    item={item}
                >
                    <b>{item.nome}</b>
                    <Divider />
                    <Stack spacing={0}>
                        {item.responsaveis && item.responsaveis.map((m) =>
                            <Typography key={'res-' + m.nome}>{m.nome}</Typography>
                        )}
                    </Stack>
                    <Divider />
                    {/* <Stack spacing={0}> */}
                    <List
                        sx={{
                            width: '100%',
                            maxWidth: 360,
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 80,
                            '& ul': { padding: 0 },
                        }}
                        subheader={<li />}
                    >
                        {item.membros && item.membros.map((m) =>
                            <Typography key={'mem-' + m.nome}>{m.nome}</Typography>
                        )}
                    </List>
                    {/* </Stack> */}
                </StyledNode>
            }
            >
                {item.lstArvore && item.lstArvore.map((row, index) =>
                    <TreeRecursivo key={item.nome + "-id-" + index} item={row} />
                )}
            </TreeNode>
        )
    }

    return (
        <MyPaper>
            <Stack>
                <Typography align="center">
                    <strong>Nome: </strong>{    prof.profile.nome},
                    <strong> Login: </strong>{  prof.profile.login},
                    <strong> Apelido: </strong>{prof.profile.nickName},
                    <strong> Email: </strong>{  prof.profile.email}
                </Typography>

                <Grid container spacing={2}>
                    <Grid size={8} sx={{ marginTop: '20px' }}>
                        <Typography align="center">{org?"Meu organograma":"Não tem organograma. Informe o responsável"}</Typography>
                        {org && <Tree
                            lineWidth={'2px'}
                            lineColor={'green'}
                            lineBorderRadius={'10px'}
                            label={
                                <StyledNode >
                                    <b>{org.nome}</b>
                                    <Divider />
                                    <Stack spacing={0}>
                                        {org.responsaveis && org.responsaveis.map((m) =>
                                            <Typography key={'res-' + m.nome}>{m.nome}</Typography>
                                        )}
                                    </Stack>
                                    <Divider />
                                    <List
                                        sx={{
                                            width: '100%',
                                            maxWidth: 360,
                                            bgcolor: 'background.paper',
                                            position: 'relative',
                                            overflow: 'auto',
                                            maxHeight: 80,
                                            '& ul': { padding: 0 },
                                        }}
                                        subheader={<li />}
                                    >
                                        {org.membros && org.membros.map((m) =>
                                            <Typography key={'mem-' + m.nome}>{m.nome}</Typography>
                                        )}
                                    </List>
                                </StyledNode>
                            }
                        >
                            {org && org.lstArvore && org.lstArvore.map((arv, index) =>
                                <TreeRecursivo key={"id-" + index} item={arv} />
                            )}
                        </Tree>}
                    </Grid>
                    { prof.profile.rules.length > 0 && 
                    <Grid size={4}>
                        { !solicitarAcesso && 
                        <Typography align="center">Acessos</Typography>}
                        {solicitarAcesso && <Box sx={{
                            textAlign: "center"
                        }}>
                        <Button onClick={handleAcesso} variant="outlined">{getBtnNome()}</Button> </Box>}
                        <Paper>
                            <List dense={true} sx={{
                                width: '100%', bgcolor: 'background.paper', overflow: 'auto',
                                maxHeight: 450,
                                '& ul': { padding: 0 },
                            }}
                            >
                                {regras && regras.map((row, id) => {
                                    const labelId = `checkbox-list-label-${id}`;
                                    return (
                                        <ListItem
                                            key={id}
                                            disablePadding
                                        >
                                            <ListItemButton role={undefined} onClick={handleToggle(row.nome)} dense>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={checked.includes(row.nome)}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText id={labelId} primary={`${row.nome}`}
                                                    secondary={`${row.descricao}`}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    )
                                })}
                            </List>
                        </Paper>
                    </Grid>}

                </Grid>
            </Stack>
        </MyPaper>
    );
}

const StyledNode = (props) => {
    const { children } = props

    return (
        <div style={{
            padding: '5px',
            borderRadius: '8px',
            display: 'inline-block',
            border: '1px solid green',
            cursor: 'pointer',
            minHeight: 60,
            minWidth: 160
        }}

        >
            {children}
        </div>
    )
}